import { useEffect } from "react";
import AboutPageText from "../components/AboutPageText";

function About(props) {
    useEffect(() => {
        props.funcNav(true);
        window.scrollTo(0, 0);
    }, [props]);

    return (
        <main>
            <AboutPageText />
        </main>
    )

}
export default About;